// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-wrapper {
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}

/* SLOT LABEL */
.fc .fc-timegrid-slot-label {
  color: #8c8c8c;
  font-size: 13px;
}

.fc .fc-timegrid-slot {
  height: 50px;
}

/* EVENT HARNESS */
.fc .fc-timegrid-event-harness {
  position: absolute !important;
  margin-right: 4px !important;
  width: 100% !important;
}

/* EVENT HARNESS CONTAINER */
.fc .fc-timegrid-event-harness-inset {
  display: flex !important;
  gap: 2px; /* smaller gap = more width */
}
.fc-direction-ltr .fc-timegrid-col-events {
  margin: 0 2px;
}
/* EVENT CARD */
.fc .fc-timegrid-event {
  border: none;
  border-radius: 0 6px 6px 0;
  padding: 8px 6px;
  min-height: 60px;
  height: 100%;
  /* overflow: hidden; */
  background-color: #f8fafc;
  margin: 2px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  box-sizing: border-box;
  display: block;
}

/* CONTENT WRAPPER */
.custom-event {
  height: 100%;
  overflow: hidden;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  /* gap: 2px; */
  width: 100%;
  min-width: 0;
}

/* EVENT MAIN */
.fc .fc-event-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  /* overflow: hidden; */
}

/* EVENT TIME */
.fc .fc-event-time {
  font-weight: 600;
  font-size: 13px;
  color: #333;
}

/* EVENT TITLE */
.fc .fc-event-title {
  font-weight: 600;
  font-size: 13px;
  color: #555;
  line-height: 1.3;
}

/* TEXT WRAP */
.custom-event div {
  white-space: normal;
  word-break: break-word;
  overflow: hidden;
}

/* + MORE BUTTON */
.event-more {
  display: none;
  color: #037fe8;
  font-size: 12px;
  cursor: pointer;
  font-weight: 500;
}

.custom-event.has-overflow .event-more {
  display: block;
}

/* GRID */
.fc-scrollgrid {
  border-radius: 8px;
  overflow: hidden;
}

.fc-timegrid-body {
  overflow: visible !important;
}

/* HEADER */
.fc .fc-scrollgrid-section-header td {
  background: transparent;
}

.fc .fc-col-header-cell-cushion {
  font-weight: 600;
  font-size: 14px;
  color: #1e293b !important;
  text-decoration: none !important;
  padding: 10px 8px;
}

.fc .fc-col-header-cell {
  text-align: left !important;
  padding-left: 8px !important;
}

/* HOVER */
.fc .fc-timegrid-event:hover {
  background-color: #edf2f7;
}

/* TRANSPARENT CALENDAR */
.fc {
  background-color: transparent !important;
}

.fc .fc-scrollgrid {
  background-color: transparent !important;
}

.fc .fc-timegrid-slot,
.fc .fc-timegrid-col {
  background-color: transparent !important;
}

.fc .fc-col-header-cell {
  background-color: transparent !important;
}

/* HIDE EMPTY EVENTS */
.visibilityHidden {
  visibility: hidden;
}

/* MOBILE STYLES */
@media (max-width: 767px) {
  /* .calendar-wrapper used to be hidden here with no phone alternative, leaving the
     Calendar page blank. CalendarPage now renders MobileDayAgenda on phones and the
     grid everywhere else, so nothing to hide. */

  .desktop-only {
    display: none !important;
  }

  .mobile-only-section {
    display: block;
  }

  .row-cols-md-3 .col,
  .row-cols-lg-4 .col {
    width: 50% !important;
  }

  .mobile-search {
    height: 44px;
    padding-left: 38px;
    border-radius: 10px;
    background: #f8f9fa;
    border: 1px solid #e3ebf8;
  }

  .mobile-search-icon {
    position: absolute;
    top: 13px;
    left: 12px;
    color: #999;
  }

  .mobile-date-strip {
    display: flex;
    overflow-x: auto;
    gap: 10px;
    margin: 15px 0;
  }

  .mobile-date-box {
    min-width: 60px;
    padding: 10px;
    text-align: center;
    border-radius: 12px;
    background: #f1f3f5;
    font-weight: 600;
  }

  .mobile-date-box.active {
    background: #dc3545;
    color: #fff;
  }

  .mobile-booking-card {
    background: #ffffff;
    padding: 14px;
    margin-bottom: 12px;
    border-radius: 14px;
    border: 1px solid #e3ebf8;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  }

  .mobile-status {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    margin-top: 6px;
  }
}

@media (min-width: 768px) {
  .mobile-only-section {
    display: none;
  }
}
@media (max-width: 767.98px) {
  /* .calendar-container {
    overflow-x: auto;
  } */

  /*  FIX HEADER IN ONE LINE */
  .fc .fc-toolbar {
    display: flex !important;
    flex-direction: row !important; /*  change from column → row */
    justify-content: space-between !important;
    align-items: center !important;
    flex-wrap: nowrap !important;
  }

  .bookingCalender .fc-header-toolbar {
    margin-top: 1rem;
    position: initial;
    top: 16.5rem;
    width: 100%;
  }

  .fc-scroller {
    overflow-x: auto !important;
  }
  /* Left side (date) */
  .fc-toolbar-title {
    font-size: 14px !important;
    text-align: left !important;
    white-space: nowrap;
  }

  /* Right side buttons (today, prev, next) */
  .fc-toolbar-chunk:last-child {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  /* Reduce button size for mobile */
  .fc-button {
    padding: 4px 8px !important;
    font-size: 12px !important;
  }

  /* Other existing styles */
  .fc-col-header-cell {
    text-align: center !important;
    font-size: 12px !important;
    padding: 6px 2px !important;
  }

  .fc-datagrid-header,
  .fc-col-header {
    min-width: 600px;
  }

  .fc-scroller {
    overflow-x: auto !important;
  }

  .fc-timegrid-slot {
    height: 40px !important;
  }

  .custom-event {
    font-size: 11px;
  }
}
@media (max-width: 767.98px) {
  /* Fix header & body scroll sync */
  .fc-timegrid-body {
    overflow: hidden !important;
  }

  .fc .fc-scroller {
    overflow-x: auto !important;
    overflow-y: auto !important;
  }

  .fc-scrollgrid-section-header {
    overflow: hidden !important;
  }

  .fc-datagrid-header,
  .fc-col-header {
    min-width: auto !important;
  }
}
.calendar-scroll {
  overflow-x: auto !important;
  overflow-y: hidden;
}

.fc .fc-scroller-harness,
.fc .fc-scroller {
  overflow-x: auto !important;
}

/* .fc .fc-header-toolbar {
  top: 0;
  z-index: 100;
  background: #fff;
    margin-right: 550px;

}

.fc .fc-col-header {
  position: sticky;
  top: 50px;
  z-index: 90;
  background: #fff;
} */
.calendar-external-header {
  position: sticky;
  top: 0;
  z-index: 999;
  background: #fff;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 12px 16px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

/* LEFT DATE */
.calendar-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.01em;
}

/* BUTTON GROUP */
.calendar-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* BASE BUTTON */
.cal-btn {
  background: #d01c4c;
  color: #fff;

  border: none;
  border-radius: 6px;

  padding: 6px 14px;
  font-size: 14px;
  font-weight: 600;

  cursor: pointer;
  transition: 0.2s ease;
  min-width: 36px;
}

/* TODAY BUTTON */
.today-btn {
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 6px;
}

/* ACTIVE TODAY STATE */
.active-today {
  background: rgba(208, 28, 76, 0.12) !important;
  color: #d01c4c !important;
  border: 1px solid rgba(208, 28, 76, 0.4);
}

/* HOVER */
.cal-btn:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

/* CLICK */
.cal-btn:active {
  transform: scale(0.96);
}

/* Submit button in calendar toolbar */
.fc .fc-submitButton-button {
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
  color: #fff !important;
  font-weight: 500;
  transition: opacity 0.2s, background-color 0.2s;
}

.fc .fc-submitButton-button:hover:not(:disabled) {
  background-color: #bb2d3b !important;
  border-color: #b02a37 !important;
}

.fc .fc-submitButton-button:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
}
/* =========================
   GRID WRAPPER (IMPORTANT)
========================= */
.dashboard-tiles {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 12px;
  margin: 10px;
}

/* CARD */
.dashboard-tile {
  width: 100%;
}

.tile-card {
  height: 100px !important;
  width: 100%;
  border-radius: 12px;
  border: 1px solid #E3EBF8;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  overflow: hidden;
}

/* ICON */
.icon-box {
  min-width: 48px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 14px;
  background: #f8f9fa;
}

/* LABEL */
.tile-label {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* VALUE */
.tile-value {
  font-size: 18px;
  font-weight: 700;
  margin: 4px 0 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* =========================
   SMALL LAPTOP / LARGE TABLET
   (1024px–1280px — 7 tiles get too
   narrow here, drop to 4 per row)
========================= */
@media (max-width: 1280px) {
  .dashboard-tiles {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* =========================
   TABLET
========================= */
@media (max-width: 992px) {
  .dashboard-tiles {
    grid-template-columns: repeat(3, 1fr);
  }

  .tile-card {
    height: 95px !important;
  }
}

/* =========================
   MOBILE
========================= */
@media (max-width: 576px) {
  .dashboard-tiles {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin: 8px;
  }

  .tile-card {
    height: 90px !important;
    padding: 10px !important;
  }

  .icon-box {
    min-width: 40px;
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }

  .tile-label {
    font-size: 11px;
  }

  .tile-value {
    font-size: 15px;
  }
}
/* =========================
   CARD STYLE
========================= */
.tile-card {
  cursor: pointer;
  border-radius: 12px;
  height: 90px;
  border: 1px solid #E3EBF8;
  width: 100%;
  overflow: hidden;
}

/* ICON */
.icon-box {
  border-radius: 50%;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

/* TEXT */
.tile-label {
  font-size: 13px;
  margin-bottom: 2px;
  white-space: nowrap;
}

.tile-value {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
}
.dashboard-cards {
  display: flex;
  flex-wrap: wrap;
}

.dashboard-card-col {
  flex: 0 0 20%;
  max-width: 20%;
}

/* Tablet */
@media (max-width: 992px) {
  .dashboard-card-col {
    flex: 0 0 33.33%;
    max-width: 33.33%;
  }
}

/* Mobile */
@media (max-width: 576px) {
  .dashboard-card-col {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .dashboard-card-col .card {
    height: auto !important;
    padding: 12px !important;
  }

  .dashboard-card-col .card h5 {
    font-size: 16px !important;
  }

  .dashboard-card-col .card div {
    font-size: 12px !important;
  }
}

/* =========================
   KPI TILE HOVER
========================= */
.kpi-tile:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.10) !important;
}

/* =========================
   NEW APPOINTMENT BUTTON
========================= */
.new-appt-btn {
  font-size: 13px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  letter-spacing: 0.02em;
  box-shadow: 0 2px 6px rgba(201, 25, 74, 0.22);
  transition: all 0.2s ease;
}

.new-appt-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(201, 25, 74, 0.32);
}

/* =========================
   MOBILE BOOKING CARD ACCENT
========================= */
@media (max-width: 767px) {
  .mobile-booking-card {
    border-left: 3px solid #c9194a !important;
  }
}

/* =========================
   CALENDAR RESOURCE HEADER — PILL BADGE
========================= */
.crew-header-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
}

.crew-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #c9194a;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0;
}

.crew-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.crew-name {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.2;
}

.crew-service {
  font-size: 11px;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  line-height: 1.3;
}

/* =========================
   BOOKING CALENDAR TOOLBAR
   Scoped to .bookingCalender (Modal.Body class in Bookings.jsx)
   Styles FullCalendar's built-in toolbar to match Dashboard's
   custom external header look.
========================= */

/* Toolbar wrapper */
.bookingCalender .fc .fc-header-toolbar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  margin-bottom: 0;
  padding: 12px 16px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  align-items: center;
}

/* Date title */
.bookingCalender .fc .fc-toolbar-title {
  font-size: 1.05rem !important;
  font-weight: 700 !important;
  color: #1e293b !important;
  letter-spacing: -0.01em;
}

/* All fc buttons base style */
.bookingCalender .fc .fc-button {
  background: #d01c4c !important;
  color: #fff !important;
  border: none !important;
  border-radius: 6px !important;
  padding: 6px 14px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease !important;
  text-transform: capitalize;
  box-shadow: none !important;
}

.bookingCalender .fc .fc-button:focus {
  box-shadow: none !important;
  outline: none !important;
}

.bookingCalender .fc .fc-button:hover:not(:disabled) {
  opacity: 0.88 !important;
  transform: translateY(-1px) !important;
  background: #d01c4c !important;
}

.bookingCalender .fc .fc-button:active {
  transform: scale(0.96) !important;
}

/* Today button — active state when viewing today */
.bookingCalender .fc .fc-button-primary:not(:disabled).fc-button-active,
.bookingCalender .fc .fc-today-button:not(:disabled) {
  background: rgba(208, 28, 76, 0.12) !important;
  color: #d01c4c !important;
  border: 1px solid rgba(208, 28, 76, 0.35) !important;
}

/* Prev / Next arrow buttons — slightly narrower */
.bookingCalender .fc .fc-prev-button,
.bookingCalender .fc .fc-next-button {
  padding: 6px 10px !important;
  font-size: 16px !important;
}

/* Submit button */
.bookingCalender .fc .fc-submitButton-button {
  background: #c9194a !important;
  border-color: #c9194a !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  padding: 7px 18px !important;
  letter-spacing: 0.02em !important;
  box-shadow: 0 2px 6px rgba(201, 25, 74, 0.22) !important;
  transition: all 0.2s ease !important;
  margin-left: 4px;
}

.bookingCalender .fc .fc-submitButton-button:hover:not(:disabled) {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(201, 25, 74, 0.32) !important;
  background: #c9194a !important;
  border-color: #c9194a !important;
}

.bookingCalender .fc .fc-submitButton-button:disabled {
  opacity: 0.38 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Column header cushion inside booking modal */
.bookingCalender .fc .fc-col-header-cell-cushion {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b !important;
  text-decoration: none !important;
  padding: 10px 8px;
}

/* Slot label inside booking modal */
.bookingCalender .fc .fc-timegrid-slot-label {
  color: #8c8c8c;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/calendar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,wBAAwB;EACxB,QAAQ,EAAE,6BAA6B;AACzC;AACA;EACE,aAAa;AACf;AACA,eAAe;AACf;EACE,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE;;gDAE8C;;EAE9C;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;EAC3C;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;;KAEG;;EAEH,4BAA4B;EAC5B;IACE,wBAAwB;IACxB,8BAA8B,EAAE,8BAA8B;IAC9D,yCAAyC;IACzC,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;EACA,qBAAqB;EACrB;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA,2CAA2C;EAC3C;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA,kCAAkC;EAClC;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,0BAA0B;EAC1B;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE,kCAAkC;EAClC;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;;GAaG;AACH;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;;EAEhB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,WAAW;;EAEX,YAAY;EACZ,kBAAkB;;EAElB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;EAEhB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA,UAAU;AACV;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;AACA;;2BAE2B;AAC3B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,YAAY;AACd;;AAEA,SAAS;AACT;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;;EAE3B,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;;EAEf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;2BAI2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;;2BAE2B;AAC3B;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;;2BAE2B;AAC3B;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;;2BAE2B;AAC3B;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,WAAW;AACX;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;2BAE2B;AAC3B;EACE,qDAAqD;AACvD;;AAEA;;2BAE2B;AAC3B;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;2BAE2B;AAC3B;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;2BAK2B;;AAE3B,oBAAoB;AACpB;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,mFAAmF;EACnF,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,mDAAmD;AACnD;;EAEE,8CAA8C;EAC9C,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA,kDAAkD;AAClD;;EAEE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,iCAAiC;EACjC,wDAAwD;EACxD,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,yDAAyD;EACzD,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".calendar-wrapper {\n  padding: 16px;\n  background-color: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n/* SLOT LABEL */\n.fc .fc-timegrid-slot-label {\n  color: #8c8c8c;\n  font-size: 13px;\n}\n\n.fc .fc-timegrid-slot {\n  height: 50px;\n}\n\n/* EVENT HARNESS */\n.fc .fc-timegrid-event-harness {\n  position: absolute !important;\n  margin-right: 4px !important;\n  width: 100% !important;\n}\n\n/* EVENT HARNESS CONTAINER */\n.fc .fc-timegrid-event-harness-inset {\n  display: flex !important;\n  gap: 2px; /* smaller gap = more width */\n}\n.fc-direction-ltr .fc-timegrid-col-events {\n  margin: 0 2px;\n}\n/* EVENT CARD */\n.fc .fc-timegrid-event {\n  border: none;\n  border-radius: 0 6px 6px 0;\n  padding: 8px 6px;\n  min-height: 60px;\n  height: 100%;\n  /* overflow: hidden; */\n  background-color: #f8fafc;\n  margin: 2px;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  box-sizing: border-box;\n  display: block;\n}\n\n/* CONTENT WRAPPER */\n.custom-event {\n  height: 100%;\n  overflow: hidden;\n  font-size: 13px;\n  display: flex;\n  flex-direction: column;\n  /* gap: 2px; */\n  width: 100%;\n  min-width: 0;\n}\n\n/* EVENT MAIN */\n.fc .fc-event-main {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  /* overflow: hidden; */\n}\n\n/* EVENT TIME */\n.fc .fc-event-time {\n  font-weight: 600;\n  font-size: 13px;\n  color: #333;\n}\n\n/* EVENT TITLE */\n.fc .fc-event-title {\n  font-weight: 600;\n  font-size: 13px;\n  color: #555;\n  line-height: 1.3;\n}\n\n/* TEXT WRAP */\n.custom-event div {\n  white-space: normal;\n  word-break: break-word;\n  overflow: hidden;\n}\n\n/* + MORE BUTTON */\n.event-more {\n  display: none;\n  color: #037fe8;\n  font-size: 12px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.custom-event.has-overflow .event-more {\n  display: block;\n}\n\n/* GRID */\n.fc-scrollgrid {\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.fc-timegrid-body {\n  overflow: visible !important;\n}\n\n/* HEADER */\n.fc .fc-scrollgrid-section-header td {\n  background: transparent;\n}\n\n.fc .fc-col-header-cell-cushion {\n  font-weight: 600;\n  font-size: 14px;\n  color: #1e293b !important;\n  text-decoration: none !important;\n  padding: 10px 8px;\n}\n\n.fc .fc-col-header-cell {\n  text-align: left !important;\n  padding-left: 8px !important;\n}\n\n/* HOVER */\n.fc .fc-timegrid-event:hover {\n  background-color: #edf2f7;\n}\n\n/* TRANSPARENT CALENDAR */\n.fc {\n  background-color: transparent !important;\n}\n\n.fc .fc-scrollgrid {\n  background-color: transparent !important;\n}\n\n.fc .fc-timegrid-slot,\n.fc .fc-timegrid-col {\n  background-color: transparent !important;\n}\n\n.fc .fc-col-header-cell {\n  background-color: transparent !important;\n}\n\n/* HIDE EMPTY EVENTS */\n.visibilityHidden {\n  visibility: hidden;\n}\n\n/* MOBILE STYLES */\n@media (max-width: 767px) {\n  /* .calendar-wrapper used to be hidden here with no phone alternative, leaving the\n     Calendar page blank. CalendarPage now renders MobileDayAgenda on phones and the\n     grid everywhere else, so nothing to hide. */\n\n  .desktop-only {\n    display: none !important;\n  }\n\n  .mobile-only-section {\n    display: block;\n  }\n\n  .row-cols-md-3 .col,\n  .row-cols-lg-4 .col {\n    width: 50% !important;\n  }\n\n  .mobile-search {\n    height: 44px;\n    padding-left: 38px;\n    border-radius: 10px;\n    background: #f8f9fa;\n    border: 1px solid #e3ebf8;\n  }\n\n  .mobile-search-icon {\n    position: absolute;\n    top: 13px;\n    left: 12px;\n    color: #999;\n  }\n\n  .mobile-date-strip {\n    display: flex;\n    overflow-x: auto;\n    gap: 10px;\n    margin: 15px 0;\n  }\n\n  .mobile-date-box {\n    min-width: 60px;\n    padding: 10px;\n    text-align: center;\n    border-radius: 12px;\n    background: #f1f3f5;\n    font-weight: 600;\n  }\n\n  .mobile-date-box.active {\n    background: #dc3545;\n    color: #fff;\n  }\n\n  .mobile-booking-card {\n    background: #ffffff;\n    padding: 14px;\n    margin-bottom: 12px;\n    border-radius: 14px;\n    border: 1px solid #e3ebf8;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);\n  }\n\n  .mobile-status {\n    display: inline-block;\n    padding: 3px 10px;\n    border-radius: 20px;\n    font-size: 11px;\n    margin-top: 6px;\n  }\n}\n\n@media (min-width: 768px) {\n  .mobile-only-section {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  /* .calendar-container {\n    overflow-x: auto;\n  } */\n\n  /*  FIX HEADER IN ONE LINE */\n  .fc .fc-toolbar {\n    display: flex !important;\n    flex-direction: row !important; /*  change from column → row */\n    justify-content: space-between !important;\n    align-items: center !important;\n    flex-wrap: nowrap !important;\n  }\n\n  .bookingCalender .fc-header-toolbar {\n    margin-top: 1rem;\n    position: initial;\n    top: 16.5rem;\n    width: 100%;\n  }\n\n  .fc-scroller {\n    overflow-x: auto !important;\n  }\n  /* Left side (date) */\n  .fc-toolbar-title {\n    font-size: 14px !important;\n    text-align: left !important;\n    white-space: nowrap;\n  }\n\n  /* Right side buttons (today, prev, next) */\n  .fc-toolbar-chunk:last-child {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  /* Reduce button size for mobile */\n  .fc-button {\n    padding: 4px 8px !important;\n    font-size: 12px !important;\n  }\n\n  /* Other existing styles */\n  .fc-col-header-cell {\n    text-align: center !important;\n    font-size: 12px !important;\n    padding: 6px 2px !important;\n  }\n\n  .fc-datagrid-header,\n  .fc-col-header {\n    min-width: 600px;\n  }\n\n  .fc-scroller {\n    overflow-x: auto !important;\n  }\n\n  .fc-timegrid-slot {\n    height: 40px !important;\n  }\n\n  .custom-event {\n    font-size: 11px;\n  }\n}\n@media (max-width: 767.98px) {\n  /* Fix header & body scroll sync */\n  .fc-timegrid-body {\n    overflow: hidden !important;\n  }\n\n  .fc .fc-scroller {\n    overflow-x: auto !important;\n    overflow-y: auto !important;\n  }\n\n  .fc-scrollgrid-section-header {\n    overflow: hidden !important;\n  }\n\n  .fc-datagrid-header,\n  .fc-col-header {\n    min-width: auto !important;\n  }\n}\n.calendar-scroll {\n  overflow-x: auto !important;\n  overflow-y: hidden;\n}\n\n.fc .fc-scroller-harness,\n.fc .fc-scroller {\n  overflow-x: auto !important;\n}\n\n/* .fc .fc-header-toolbar {\n  top: 0;\n  z-index: 100;\n  background: #fff;\n    margin-right: 550px;\n\n}\n\n.fc .fc-col-header {\n  position: sticky;\n  top: 50px;\n  z-index: 90;\n  background: #fff;\n} */\n.calendar-external-header {\n  position: sticky;\n  top: 0;\n  z-index: 999;\n  background: #fff;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  padding: 12px 16px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);\n}\n\n/* LEFT DATE */\n.calendar-title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1e293b;\n  letter-spacing: -0.01em;\n}\n\n/* BUTTON GROUP */\n.calendar-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n/* BASE BUTTON */\n.cal-btn {\n  background: #d01c4c;\n  color: #fff;\n\n  border: none;\n  border-radius: 6px;\n\n  padding: 6px 14px;\n  font-size: 14px;\n  font-weight: 600;\n\n  cursor: pointer;\n  transition: 0.2s ease;\n  min-width: 36px;\n}\n\n/* TODAY BUTTON */\n.today-btn {\n  font-size: 13px;\n  font-weight: 600;\n  padding: 6px 14px;\n  border-radius: 6px;\n}\n\n/* ACTIVE TODAY STATE */\n.active-today {\n  background: rgba(208, 28, 76, 0.12) !important;\n  color: #d01c4c !important;\n  border: 1px solid rgba(208, 28, 76, 0.4);\n}\n\n/* HOVER */\n.cal-btn:hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n/* CLICK */\n.cal-btn:active {\n  transform: scale(0.96);\n}\n\n/* Submit button in calendar toolbar */\n.fc .fc-submitButton-button {\n  background-color: #dc3545 !important;\n  border-color: #dc3545 !important;\n  color: #fff !important;\n  font-weight: 500;\n  transition: opacity 0.2s, background-color 0.2s;\n}\n\n.fc .fc-submitButton-button:hover:not(:disabled) {\n  background-color: #bb2d3b !important;\n  border-color: #b02a37 !important;\n}\n\n.fc .fc-submitButton-button:disabled {\n  opacity: 0.4 !important;\n  cursor: not-allowed !important;\n}\n/* =========================\n   GRID WRAPPER (IMPORTANT)\n========================= */\n.dashboard-tiles {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 12px;\n  margin: 10px;\n}\n\n/* CARD */\n.dashboard-tile {\n  width: 100%;\n}\n\n.tile-card {\n  height: 100px !important;\n  width: 100%;\n  border-radius: 12px;\n  border: 1px solid #E3EBF8;\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  overflow: hidden;\n}\n\n/* ICON */\n.icon-box {\n  min-width: 48px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  flex-shrink: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin-right: 14px;\n  background: #f8f9fa;\n}\n\n/* LABEL */\n.tile-label {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* VALUE */\n.tile-value {\n  font-size: 18px;\n  font-weight: 700;\n  margin: 4px 0 0;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* =========================\n   SMALL LAPTOP / LARGE TABLET\n   (1024px–1280px — 7 tiles get too\n   narrow here, drop to 4 per row)\n========================= */\n@media (max-width: 1280px) {\n  .dashboard-tiles {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* =========================\n   TABLET\n========================= */\n@media (max-width: 992px) {\n  .dashboard-tiles {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .tile-card {\n    height: 95px !important;\n  }\n}\n\n/* =========================\n   MOBILE\n========================= */\n@media (max-width: 576px) {\n  .dashboard-tiles {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    margin: 8px;\n  }\n\n  .tile-card {\n    height: 90px !important;\n    padding: 10px !important;\n  }\n\n  .icon-box {\n    min-width: 40px;\n    width: 40px;\n    height: 40px;\n    margin-right: 10px;\n  }\n\n  .tile-label {\n    font-size: 11px;\n  }\n\n  .tile-value {\n    font-size: 15px;\n  }\n}\n/* =========================\n   CARD STYLE\n========================= */\n.tile-card {\n  cursor: pointer;\n  border-radius: 12px;\n  height: 90px;\n  border: 1px solid #E3EBF8;\n  width: 100%;\n  overflow: hidden;\n}\n\n/* ICON */\n.icon-box {\n  border-radius: 50%;\n  width: 42px;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n}\n\n/* TEXT */\n.tile-label {\n  font-size: 13px;\n  margin-bottom: 2px;\n  white-space: nowrap;\n}\n\n.tile-value {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0;\n  white-space: nowrap;\n}\n.dashboard-cards {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dashboard-card-col {\n  flex: 0 0 20%;\n  max-width: 20%;\n}\n\n/* Tablet */\n@media (max-width: 992px) {\n  .dashboard-card-col {\n    flex: 0 0 33.33%;\n    max-width: 33.33%;\n  }\n}\n\n/* Mobile */\n@media (max-width: 576px) {\n  .dashboard-card-col {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .dashboard-card-col .card {\n    height: auto !important;\n    padding: 12px !important;\n  }\n\n  .dashboard-card-col .card h5 {\n    font-size: 16px !important;\n  }\n\n  .dashboard-card-col .card div {\n    font-size: 12px !important;\n  }\n}\n\n/* =========================\n   KPI TILE HOVER\n========================= */\n.kpi-tile:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.10) !important;\n}\n\n/* =========================\n   NEW APPOINTMENT BUTTON\n========================= */\n.new-appt-btn {\n  font-size: 13px;\n  font-weight: 600;\n  padding: 8px 16px;\n  border-radius: 8px;\n  letter-spacing: 0.02em;\n  box-shadow: 0 2px 6px rgba(201, 25, 74, 0.22);\n  transition: all 0.2s ease;\n}\n\n.new-appt-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(201, 25, 74, 0.32);\n}\n\n/* =========================\n   MOBILE BOOKING CARD ACCENT\n========================= */\n@media (max-width: 767px) {\n  .mobile-booking-card {\n    border-left: 3px solid #c9194a !important;\n  }\n}\n\n/* =========================\n   CALENDAR RESOURCE HEADER — PILL BADGE\n========================= */\n.crew-header-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 0;\n}\n\n.crew-avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: #c9194a;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  letter-spacing: 0;\n}\n\n.crew-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.crew-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.2;\n}\n\n.crew-service {\n  font-size: 11px;\n  color: #94a3b8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 140px;\n  line-height: 1.3;\n}\n\n/* =========================\n   BOOKING CALENDAR TOOLBAR\n   Scoped to .bookingCalender (Modal.Body class in Bookings.jsx)\n   Styles FullCalendar's built-in toolbar to match Dashboard's\n   custom external header look.\n========================= */\n\n/* Toolbar wrapper */\n.bookingCalender .fc .fc-header-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: #fff;\n  margin-bottom: 0;\n  padding: 12px 16px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);\n  align-items: center;\n}\n\n/* Date title */\n.bookingCalender .fc .fc-toolbar-title {\n  font-size: 1.05rem !important;\n  font-weight: 700 !important;\n  color: #1e293b !important;\n  letter-spacing: -0.01em;\n}\n\n/* All fc buttons base style */\n.bookingCalender .fc .fc-button {\n  background: #d01c4c !important;\n  color: #fff !important;\n  border: none !important;\n  border-radius: 6px !important;\n  padding: 6px 14px !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease !important;\n  text-transform: capitalize;\n  box-shadow: none !important;\n}\n\n.bookingCalender .fc .fc-button:focus {\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.bookingCalender .fc .fc-button:hover:not(:disabled) {\n  opacity: 0.88 !important;\n  transform: translateY(-1px) !important;\n  background: #d01c4c !important;\n}\n\n.bookingCalender .fc .fc-button:active {\n  transform: scale(0.96) !important;\n}\n\n/* Today button — active state when viewing today */\n.bookingCalender .fc .fc-button-primary:not(:disabled).fc-button-active,\n.bookingCalender .fc .fc-today-button:not(:disabled) {\n  background: rgba(208, 28, 76, 0.12) !important;\n  color: #d01c4c !important;\n  border: 1px solid rgba(208, 28, 76, 0.35) !important;\n}\n\n/* Prev / Next arrow buttons — slightly narrower */\n.bookingCalender .fc .fc-prev-button,\n.bookingCalender .fc .fc-next-button {\n  padding: 6px 10px !important;\n  font-size: 16px !important;\n}\n\n/* Submit button */\n.bookingCalender .fc .fc-submitButton-button {\n  background: #c9194a !important;\n  border-color: #c9194a !important;\n  color: #fff !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  border-radius: 8px !important;\n  padding: 7px 18px !important;\n  letter-spacing: 0.02em !important;\n  box-shadow: 0 2px 6px rgba(201, 25, 74, 0.22) !important;\n  transition: all 0.2s ease !important;\n  margin-left: 4px;\n}\n\n.bookingCalender .fc .fc-submitButton-button:hover:not(:disabled) {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 12px rgba(201, 25, 74, 0.32) !important;\n  background: #c9194a !important;\n  border-color: #c9194a !important;\n}\n\n.bookingCalender .fc .fc-submitButton-button:disabled {\n  opacity: 0.38 !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Column header cushion inside booking modal */\n.bookingCalender .fc .fc-col-header-cell-cushion {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b !important;\n  text-decoration: none !important;\n  padding: 10px 8px;\n}\n\n/* Slot label inside booking modal */\n.bookingCalender .fc .fc-timegrid-slot-label {\n  color: #8c8c8c;\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
